import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { setCompanyAracItem } from "../../features/companyProfile/companyProfileSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;

    .content {
      width: 100% !important;
      padding: 15px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);

      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
        }
      }
    }
  }
`;

const ProfilimAracItemContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();



  return (
    <Container theme={theme} onClick={() => {dispatch(setCompanyAracItem(data)); dispatch(showModal("companyAracItem"))}}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data.truckPlateNumber}</div>
            <div className="col">{data.truckType}</div>
            <div className="col">{data.trailerType}</div>
            <div className="col">{data.kaskoGecerlilikTarihi}</div>
            <div className="col">{data.muayeneGecerlilikTarihi}</div>
            <div className="col">{data.trafikSigortasıGecerlilikTarihi}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ProfilimAracItemContainer;
